/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_CpInputs */

const cs_projects_cp = /** @type {(inputs: Projects_CpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo popisné`)
};

const en_projects_cp = /** @type {(inputs: Projects_CpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descriptive number`)
};

/**
* | output |
* | --- |
* | "Descriptive number" |
*
* @param {Projects_CpInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_cp = /** @type {((inputs?: Projects_CpInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_CpInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_cp(inputs)
	return cs_projects_cp(inputs)
});